import type {PageRouteConfig} from '@router';

import TrackingDetails from 'modules/Tracking/TrackingDetails/TrackingDetails';
import {routes} from 'routes/routes';

export function createTrackingDetailsRoute(): PageRouteConfig {
  return {
    element: <TrackingDetails />,
    layout: {
      title: 'جزئیات پیگیری',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.TRACKING
    }
  };
}
